import { MIXPANEL_TOKENS } from './mixpanel-tokens';

export const environment = {
  apiBaseUrl: 'https://staging.api.sbv360.com',
  reportsApiUrl: 'https://report-generator-api-staging.azurewebsites.net',
  chatPublicKey: '7j2r5n773wxu',
  environment: 'stag',
  mixpanelToken: MIXPANEL_TOKENS.NON_PRODUCTION as string | undefined,
  enablePBJ: process.env.NX_FEATURE_FLAG_PBJ_ENABLED || true,
};
